"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectionDot = void 0;
/* eslint-disable import/prefer-default-export */
var react_1 = __importDefault(require("react"));
var SelectionDot = function (_a) {
    var _b = _a.size, size = _b === void 0 ? '24px' : _b, _c = _a.color, color = _c === void 0 ? 'currentColor' : _c;
    return react_1.default.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("circle", { cx: "12", cy: "12", r: "4", fill: color }));
};
exports.SelectionDot = SelectionDot;
